/* HealthCaps: progressive enhancement around the native theme/app controls. */
(() => {
  'use strict';
  const text = value => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const states = new WeakMap();

  function enhanceProduct(section) {
    const source = section.querySelector('[data-hc-product-prices]');
    if (!source) return;
    let data;
    try { data = JSON.parse(source.textContent); } catch (_) { return; }
    const form = section.querySelector('.product-info form[action*="/cart/add"]');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const selected = section.querySelector('variant-picker [data-variant]');
    let selectedId;
    try { selectedId = JSON.parse(selected?.textContent || '{}').id; } catch (_) {}
    const variant = data.variants.find(v => String(v.id) === String(selectedId || variantId)) || data.variants[0];
    if (!variant) return;
    const monthly = /maandbox|28\s*dagbox/i.test(variant.title);
    const days = monthly ? 28 : 7;
    section.querySelectorAll('[data-hc-box-count]').forEach(el => {
      if (el.textContent !== String(days)) el.textContent = String(days);
    });
    const currency = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: data.currency || 'EUR' });
    section.querySelectorAll('.sls-option-container').forEach(card => {
      const subscription = card.querySelector('input[data-type="subscription"]');
      const interval = card.querySelector('select[name="subs_interval"]');
      let plan = null;
      if (subscription && interval) {
        const choice = Array.from(interval.options).find(o => monthly
          ? /^(?:4\s*(?:weken|weeks)|28\s*(?:dagen|days))$/.test(text(o.textContent))
          : /^(?:week|1\s*(?:week|weeks)|7\s*(?:dagen|days))$/.test(text(o.textContent)));
        const wrapper = interval.closest('.sls-selling-plan-group-options');
        // Hide the redundant selector ONLY after a real, allocated interval is selected.
        const allocation = choice && variant.allocations.find(a => String(a.plan) === choice.value);
        if (choice && allocation) {
          if (interval.value !== choice.value) {
            interval.value = choice.value;
            interval.dispatchEvent(new Event('change', { bubbles: true }));
          }
          wrapper?.classList.add('hc-hide-seal-frequency');
          wrapper?.setAttribute('aria-hidden', 'true');
          plan = allocation;
        } else {
          wrapper?.classList.remove('hc-hide-seal-frequency');
          wrapper?.removeAttribute('aria-hidden');
        }
      }
      const badge = card.querySelector('.sls-savings-badge');
      if (subscription && plan && badge && variant.price > plan.price) {
        const savingLabel = 'Bespaar ' + currency.format((variant.price - plan.price) / 100);
        if (badge.textContent !== savingLabel) badge.textContent = savingLabel;
      }
      const total = subscription ? plan?.price : variant.price;
      const holder = card.querySelector('.sls-total-price');
      let daily = card.querySelector('.hc-seal-daily-price');
      if (!holder || !Number.isFinite(total)) { daily?.remove(); return; }
      if (!daily) {
        daily = document.createElement('small');
        daily.className = 'hc-seal-daily-price';
        holder.appendChild(daily);
      } else if (daily.parentElement !== holder) holder.appendChild(daily);
      const label = currency.format(total / 100 / days) + ' / dag';
      if (daily.textContent !== label) daily.textContent = label;
    });
  }

  function enhanceReviews(widget) {
    const native = widget.querySelector('.jdgm-paginate__load-more');
    const container = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!container) return;
    let state = states.get(widget);
    if (!state) { state = { visible: 3, loading: false, count: 0 }; states.set(widget, state); }
    const reviews = Array.from(container.querySelectorAll('.jdgm-rev'));
    if (state.loading && reviews.length > state.count) { state.loading = false; clearTimeout(state.timer); }
    reviews.forEach((review, index) => { review.hidden = index >= Math.min(state.visible, 15); });
    widget.classList.add('hc-reviews-enhanced');
    let control = widget.querySelector('.hc-review-more');
    if (!control) {
      control = document.createElement('button');
      control.type = 'button'; control.className = 'button hc-review-more';
      control.textContent = 'Meer beoordelingen';
      container.parentElement.appendChild(control);
      control.addEventListener('click', () => {
        const current = Array.from(container.querySelectorAll('.jdgm-rev'));
        const target = Math.min(state.visible + 2, 15);
        if (current.length >= target) { state.visible = target; enhanceReviews(widget); return; }
        const more = widget.querySelector('.jdgm-paginate__load-more');
        if (!more || state.loading) return;
        const previousVisible = state.visible;
        state.visible = target; state.count = current.length; state.loading = true;
        enhanceReviews(widget);
        // Judge.me owns the request, sort order, review data and photo lightbox.
        more.click();
        state.timer = setTimeout(() => {
          if (state.loading) state.visible = previousVisible;
          state.loading = false; enhanceReviews(widget);
        }, 12000);
      });
    }
    const total = Number(widget.dataset.numberOfReviews || widget.closest('[data-number-of-reviews]')?.dataset.numberOfReviews);
    const exhausted = Number.isFinite(total) && total > 0 && reviews.length >= total;
    control.hidden = state.visible >= 15 || (reviews.length <= state.visible && (!native || exhausted));
    control.disabled = state.loading;
    const label = state.loading ? 'Beoordelingen laden…' : 'Meer beoordelingen';
    if (control.textContent !== label) control.textContent = label;
  }

  let scheduled = false;
  function update() {
    scheduled = false;
    document.querySelectorAll('.shopify-section--main-product').forEach(enhanceProduct);
    document.querySelectorAll('#judgeme_product_reviews .jdgm-rev-widg').forEach(enhanceReviews);
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  document.addEventListener('change', schedule);
  document.addEventListener('variant:change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList')) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  update();

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-hc-nutrition-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.hcNutritionOpen);
      if (!dialog) return;
      event.preventDefault(); dialog._hcTrigger = trigger; dialog.showModal();
    }
    const closer = event.target.closest('[data-hc-dialog-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('dialog.hc-nutrition-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches?.('.hc-nutrition-dialog')) event.target._hcTrigger?.focus();
  }, true);
})();
